import { SlotSymbolProps } from '@/components/slot-reel';

const SlotSymbol = ({ symbol }: SlotSymbolProps) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      {symbol}
    </div>
  );
};

export default SlotSymbol;
